import { render, staticRenderFns } from "./ModalInfoV2.vue?vue&type=template&id=29da1a3a&scoped=true&"
import script from "./ModalInfoV2.vue?vue&type=script&lang=js&"
export * from "./ModalInfoV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoV2.vue?vue&type=style&index=0&id=29da1a3a&scoped=true&lang=css&"
import style1 from "./ModalInfoV2.vue?vue&type=style&index=1&id=29da1a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da1a3a",
  null
  
)

export default component.exports